/* eslint-disable no-sequences */
/* eslint-disable no-unused-vars */
/* eslint-disable no-param-reassign */
/* eslint-disable no-unused-expressions */

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { defaultReject, defaultState } from "../../../constants";
import { fetchData } from "../../../helpers";

// uploadPdfAndImage
// UPLOADPDFANDIMAGE
const GETEDUCATIONBYID= createAsyncThunk(
  "getEducationById/getEducationById",
  // eslint-disable-next-line default-param-last
  async (
    // eslint-disable-next-line default-param-last
    payload = {},
    { rejectWithValue }
  ) => {
    try {
      const data = await fetchData(
        payload?.data,
        payload?.method,
        payload?.apiName
      );
      return {
        ...defaultState.List,
        message: data?.data.Message,
        data: data?.data?.data,
      };
    } catch (error) {
      return rejectWithValue({
        ...defaultReject.List,
        message: error.message,
      });
    }
  }
);

// PublishPostSlice
const getEducationByIdSlice = createSlice({
  name: "getEducationByIdSlice",
  initialState: {
    getEducationById: {
      ...defaultState.List,
      loading: false, 
      error: false, 
    },
  },
  reducers: {
    setInitialStateOfgetEducationById: (state) => {
        state.getEducationById.loading = false
        state.getEducationById.error = false
        state.getEducationById.data = []
        state.getEducationById.message = ''
      }
  },
  extraReducers: (builder) => {
    builder.addCase(GETEDUCATIONBYID.fulfilled, (state, action) => {
      state.getEducationById = {
        ...state.getEducationById,
        loading: false,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETEDUCATIONBYID.pending, (state, action) => {
      state.getEducationById = {
        ...state.getEducationById,
        loading: true,
        error: false,
        ...action.payload,
      };
    });
    builder.addCase(GETEDUCATIONBYID.rejected, (state, action) => {
      state.getEducationById = {
        ...state.getEducationById,
        loading: false,
        error: true,
        ...action.payload,
      };
    });
  },
});

const getEducationByIdAction = {
    GETEDUCATIONBYID,
};

export { getEducationByIdAction };
export default getEducationByIdSlice.reducer;
export const {setInitialStateOfgetEducationById} = getEducationByIdSlice.actions